interface FormatSelectorProps {
  value: 'rtf' | 'hl7' | 'text';
  onChange: (value: 'rtf' | 'hl7' | 'text') => void;
}

export default function FormatSelector({ value, onChange }: FormatSelectorProps) {
  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value as 'rtf' | 'hl7' | 'text')}
      className="px-3 py-2 bg-white dark:bg-surface-850 border border-gray-300 dark:border-surface-800 rounded-lg text-sm text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-primary-500"
    >
      <option value="rtf">RTF (Rich Text)</option>
      <option value="hl7">HL7 (ORU^R01)</option>
      <option value="text">Plain Text</option>
    </select>
  );
}
